"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datetimeSchema = void 0;
const zod_1 = require("zod");
exports.datetimeSchema = zod_1.z
    .string()
    .datetime()
    .refine((date) => !!Date.parse(date), { message: "Invalid date format." });
//# sourceMappingURL=datetime.schema.js.map